import { render, staticRenderFns } from "./parkingAreaLimit.vue?vue&type=template&id=68a0ac1c&scoped=true"
import script from "./parkingAreaLimit.vue?vue&type=script&lang=js"
export * from "./parkingAreaLimit.vue?vue&type=script&lang=js"
import style0 from "./parkingAreaLimit.vue?vue&type=style&index=0&id=68a0ac1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a0ac1c",
  null
  
)

export default component.exports